/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_UnknownInputs */

const vi_einvoice_error_unknown = /** @type {(inputs: Einvoice_Error_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không gửi được hóa đơn sang MISA. Vui lòng thử lại; nếu vẫn lỗi, liên hệ người quản trị.`)
};

/**

* @param {Einvoice_Error_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_unknown = /** @type {((inputs?: Einvoice_Error_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_unknown(inputs)
});